var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrnament2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.81 44.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.87,
    cy: 27.28,
    rx: 11.38,
    ry: 16.96,
    fill: "#476c58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.44,6.65c0-.29,0-.57,0-.85s0-.71,0-1.07c0-1.37.1-3.72.73-3.77s0,2,.06,3l.06,2.58s0,.06,0,.1l.16,0a11.64,11.64,0,0,1,1.86.21,1.8,1.8,0,0,1,.75.36,1.36,1.36,0,0,1,.5.78,5.31,5.31,0,0,1,.1.68c0,.46,0,.92,0,1.37,0,.26,0,.52,0,.78v.09c0,.26-.06.33-.31.25a2.18,2.18,0,0,0-1.78.23.32.32,0,0,1-.35,0,2.63,2.63,0,0,0-2.13,0c-.39.15-.35.16-.74-.06a1.67,1.67,0,0,0-1.24-.17l-.38.08c-.27,0-.39,0-.43-.3s-.1-.75-.14-1.12-.06-.79-.08-1.18c0-.2,0-.4,0-.6a.77.77,0,0,1,.33-.61,2.76,2.76,0,0,1,1-.49,11.18,11.18,0,0,1,1.92-.34Z",
    fill: "#cccbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnament2);
export default __webpack_public_path__ + "static/media/ornament2.92f83f61e2ed4f51ae44fb0d873fb864.svg";
export { ForwardRef as ReactComponent };